/**
 * Season helpers for PlaceCore Season Overlays v1.
 * Sweden-friendly mapping: Winter Dec–Feb, Spring Mar–May, Summer Jun–Aug, Autumn Sep–Nov.
 */

export type Season = "winter" | "spring" | "summer" | "autumn";

/**
 * Get current season using Europe/Stockholm timezone.
 * This ensures consistent season detection regardless of browser locale.
 */
export function getCurrentSeason(d = new Date()): Season {
  // Use Intl to get the month in Europe/Stockholm timezone
  const stockholmMonth = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Stockholm',
    month: 'numeric',
  }).format(d);
  const m = parseInt(stockholmMonth, 10); // 1-12
  if (m === 12 || m === 1 || m === 2) return "winter";
  if (m >= 3 && m <= 5) return "spring";
  if (m >= 6 && m <= 8) return "summer";
  return "autumn";
}

/** Parse and validate a season string (e.g. from URL params) */
export function parseSeasonParam(value: string | null | undefined): Season | null {
  if (!value) return null;
  const lower = value.toLowerCase();
  if (ALL_SEASONS.includes(lower as Season)) return lower as Season;
  return null;
}

export function seasonLabelSv(season: Season): string {
  switch (season) {
    case "winter": return "Vinter";
    case "spring": return "Vår";
    case "summer": return "Sommar";
    case "autumn": return "Höst";
  }
}

export const ALL_SEASONS: Season[] = ["winter", "spring", "summer", "autumn"];
